import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import InfoPopup from "./infopopup";
// import BookingPopUp from "./bookingpopup";
import StarsRating from "stars-rating";

// import { stateToHTML } from 'draft-js-export-html';
// import draftToHtml from "draftjs-to-html";
import "./practitonerinfo.css";
import StripeForm from "../../../../../components/stripe";
import Paypal from "../../../../../components/paypal";
import Button from "../../../../../components/button";
import { getMediumFeedbacksList, getMediumServiceDetails, payWithPaypal, payWithSquareUp, payWithStripe } from "../../../../../services/client";
import { bo } from "@fullcalendar/core/internal-common";
import PaymentPrices from "./payment/payment";
import ThankyouPopup from "./payment/thankyou";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setPaymentMethodAvailbale, setPaymentTypeAvailbale } from "../../../../../reducer/clientsSlice";
import Prepaypostpaycheck from "../practitioners/subcomponents/prepaypostpaycheck";
import FavoriteToggle from "../favoritetoggle";
import { isHTML } from "../../../../../utils/helpers";

const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function PractitionerInfo({
  PractitionerInfo,
  onClick,
  setRenderType,
  startBookaSessionLaterVideo = { startBookaSessionLaterVideo },
  startBookaSessionLaterQuestions,
  setBookInfo,
  getSubsessions,
  onToggleFavorite = () => {},
  canFavorite = false,
  isTogglingFavorite = false,
}) {
  const dispatch = useDispatch()
  // const contentState = PractitionerInfo.general.biographical_info !== "" ? JSON.parse(PractitionerInfo.general.biographical_info) : PractitionerInfo.general.biographical_info;
  //  console.log(contentState)
  // console.log('window.paypal',window.paypal)
  // const PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });
  const auth = useSelector((state) => state.user);
  // const html = draftToHtml(contentState);
  const [active, setActive] = useState([]);
  const [redirectionUrl, setredirectionUrl] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('20');
  const [professionalInfo, setProfessionalInfo] = useState()

  const [mediumSessionInfo, setMediumSessionInfo] = useState();
  const [userCurrency, setUserCurrency] = useState('USD');

  // Client Reviews pagination: get-medium-details already comes back with
  // just the first 2 feedback entries (feedbacks_has_more tells us if
  // there's more), so we seed state from that instead of firing a second
  // request on mount. The "Load" button then fetches 5 more at a time from
  // the dedicated paginated feedbacks API.
  const LOAD_MORE_REVIEWS_LIMIT = 5;
  const [reviews, setReviews] = useState(PractitionerInfo && PractitionerInfo.feedbacks ? PractitionerInfo.feedbacks : []);
  const [reviewsOffset, setReviewsOffset] = useState(PractitionerInfo && PractitionerInfo.feedbacks ? PractitionerInfo.feedbacks.length : 0);
  const [hasMoreReviews, setHasMoreReviews] = useState(!!(PractitionerInfo && PractitionerInfo.feedbacks_has_more));
  const [loadingReviews, setLoadingReviews] = useState(false);
  const loadMoreRef = useRef(null);

  const getMediumIdSafe = () => {
    return PractitionerInfo && PractitionerInfo.general ? PractitionerInfo.general.medium_id : undefined;
  };

  const loadMoreReviews = () => {
    const medium_id = getMediumIdSafe();
    if (!medium_id) return;
    setLoadingReviews(true);
    getMediumFeedbacksList(medium_id, reviewsOffset, LOAD_MORE_REVIEWS_LIMIT)
      .then((data) => {
        if (data.data.status) {
          const { feedbacks: newFeedbacks, has_more, offset: returnedOffset, limit: returnedLimit } = data.data.data;
          setReviews((prev) => [...prev, ...newFeedbacks]);
          setReviewsOffset(returnedOffset + returnedLimit);
          setHasMoreReviews(has_more);
        }
      })
      .catch(() => { })
      .finally(() => setLoadingReviews(false));
  };

  // Infinite scroll: auto-load the next page of reviews when the sentinel
  // at the bottom of the list scrolls into view (replaces the "Load" button).
  useEffect(() => {
    if (!hasMoreReviews) return;
    const el = loadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingReviews) {
          loadMoreReviews();
        }
      },
      { root: null, rootMargin: "200px", threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMoreReviews, loadingReviews, reviewsOffset]);
  // const openPopup = () => {
  //   window.loadModal2(`#BookingPopUp`, "show");
  // }
    const iframeRef = useRef(null);
      const [iframeHeight, setIframeHeight] = useState("100px");
       useEffect(() => {
          const handleMessage = (event) => {
              if (event.data && event.data.type === "setHeight") {
                  let height =  event.data.height + 65;
              setIframeHeight(height + "px");
              }
          };

          window.addEventListener("message", handleMessage);
          return () => window.removeEventListener("message", handleMessage);
          }, []);

  const openMoreInfo = (info) => {
    console.log("admin info", [info]);
    setActive([info]);
    window.loadModal2("#infopopup", "show");
    return;
  };
  // useEffect(()=>{
  // window.loadModal2('#thankyoupopup','show')
  // },[])
  // NOTE: the overall star rating used to be computed here from
  // PractitionerInfo.feedbacks, but get-medium-details now only sends the
  // first 2 feedback entries (for load time), so the average is computed
  // server-side and returned as PractitionerInfo.general.average_rating.
  const checkValue = (item) => {
    return [1, 2, 3, 4, 5].includes(item);
  };

  const paymentMethodHandler = () => {
    let curr = PractitionerInfo.general.session_currency !== undefined && PractitionerInfo.general.session_currency !== "" && PractitionerInfo.general.session_currency !== null
      ? Object.values(JSON.parse(PractitionerInfo.general.session_currency))[0]
      : "USD";
    console.log(paymentAmount)
    let body = {
      medium_id: PractitionerInfo.general.medium_id,
      amount: paymentAmount,
      currency: curr
    }
    if (paymentType === "paypal") {
      payWithPaypal(body).then((data) => {
        if (data.data.status) {

          //  window.loadModal2('#payment-price-popup','hide')
          // setredirectionUrl(data.data.data.approvedUrl)
          // setTimeout(() => {
          window.open(data.data.data.approvedUrl, '_self');
          //   window.loadModal2('#payment-redirection-url', 'show')
          // }, 2000)
          // setTimeout(() => {

          //   window.loadModal2('#payment-redirection-url', 'hide')
          // }, 15000)
        }
      }).catch(() => { })
    }
    else if (paymentType == "stripe") {
      payWithStripe(body).then((data) => {
        if (data.data.status) {
          window.open(data.data.data.redirectUrl, '_self');
          // console.log()
          // setredirectionUrl(data.data.data.redirectUrl)
          // setTimeout(() => {

          //   window.loadModal2('#payment-redirection-url', 'show')
          // }, 2000)
          // setTimeout(() => {

          //   window.loadModal2('#payment-redirection-url', 'hide')
          // }, 15000)
        }
      }).catch(() => { })

    }
    else {
      payWithSquareUp(body).then((data) => {
        if (data.data.status) {
          window.open(data.data.data.approvedUrl, '_self');
          // console.log()
          // setredirectionUrl(data.data.data.redirectUrl)
          // setTimeout(() => {

          //   window.loadModal2('#payment-redirection-url', 'show')
          // }, 2000)
          // setTimeout(() => {

          //   window.loadModal2('#payment-redirection-url', 'hide')
          // }, 15000)
        }
      }).catch(() => { })

    }



  }
  const getBookingLink = (info) => {
    localStorage.removeItem('offset');
    setProfessionalInfo(info);

    //live start
    // if (checkPostPreType(info)) {
    //live end
    getMediumServiceDetails(info.medium_id)
      .then((data) => {
        if (data.data.status) {
          setMediumSessionInfo(data.data.data[0]);

          window.loadModal2("#Prepaypostpaycheck", "show");
        }
      })
      .catch(() => { });

    // startSeesion(info)
    // }
  };

  const startSeesion = (info) => {
    let inf = {
      general: {
        personal_booking_link: info.personal_booking_link,
        payType: info.payType,
        pre_pay_session_type: info.pre_pay_session_type,
        post_pay_session_type: info.post_pay_session_type,
        medium_id: info.medium_id,
        ...info
      },
    };
    setBookInfo(inf);
    setRenderType("newappointment");
    // {
    //   auth.user.terms_session_status === 1
    //     ? startBookaSessionLaterQuestions()
    //     : startBookaSessionLaterVideo();
    // }
  }

  const checkPostPreType = (info) => {

    let status = false;
    const { payType, post_pay_schedule, pre_pay_schedule, is_paypal_integrated, is_stripe_integrated } = info

    if (!is_paypal_integrated && !is_stripe_integrated) {
      toast.error('No Availability for this Medium', { position: 'top-center' })
      return;
    }
    else if (is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale('both'));
    }
    else if (is_paypal_integrated && !is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale('paypal'));
    }
    else if (!is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale('stripe'));
    }

    if (payType.length === 2) {
      if (!post_pay_schedule && !pre_pay_schedule) {
        // setPaytypeText('both post pay pre pay avialable for this medium')
        toast.error('No Availability for this Medium', { position: 'top-center' })
        return;
      }
      if (post_pay_schedule && pre_pay_schedule) {
        window.loadModal2('#Prepaypostpaycheck', 'show');
        // setPaytypeText('both post pay pre pay avialable for this medium')
        // toast.success('both post pay pre pay avialable for this medium', { position: 'top-center' })
        // status = true
      }
      else if (post_pay_schedule && !pre_pay_schedule) {
        window.loadModal2("#Prepaypostpaycheck", "show");
        // setPaytypeText('Only post pay avialable for this medium')
        dispatch(setPaymentTypeAvailbale('Pay After Session'))
        // getSubsessions(8)
        // status = true
        // toast.error('Only post pay avialable for this medium', { position: 'top-center' })
      }
      else if (!post_pay_schedule && pre_pay_schedule) {
        window.loadModal2("#Prepaypostpaycheck", "show");
        dispatch(setPaymentTypeAvailbale('Pay Before Session'))
        // status = true
        // setPaytypeText('Only pre pay avialable for this medium')
        // toast.error('Only pre pay avialable for this medium', { position: 'top-center' })
      }

      // else if (post_pay_schedule || pre_pay_schedule) {
      //   status = true
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error('No schedule available for this medium', { position: 'top-center' })
      }
    }
    else {
      if (payType[0] === 1 && pre_pay_schedule) {
        dispatch(setPaymentTypeAvailbale('Pay Before Session'))
        // getSubsessions(7)
        // setPaytypeText('only pre pay added and available')
        // toast.success('only pre pay added and available', { position: 'top-center' })
        status = true
      }
      // else if (payType[0] === 1 && !pre_pay_schedule) {
      //   setPaytypeText('No pre pay schedule available for this medium')
      //   toast.error('No pre pay schedule available for this medium', { position: 'top-center' })
      // }
      else if (payType[0] === 2 && post_pay_schedule) {
        dispatch(setPaymentTypeAvailbale('Pay Before Session'))
        // getSubsessions(7)
        // setPaytypeText('only post pay added and available')
        // toast.success('only post pay added and available', { position: 'top-center' })
        status = true
      }
      // else if (payType[0] === 2 && !post_pay_schedule) {
      //   setPaytypeText('No post pay schedule available for this medium')
      //   toast.error('No post pay schedule available for this medium', { position: 'top-center' })
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error('No Availability for this Medium', { position: 'top-center' })
      }
    }
    return status;
  }
  const checkWindowSize = () => {
    return window.innerWidth;
  }

  const getBio = (info) =>{
        const rawContentFromDB = info
        let html;
      if (!isHTML(rawContentFromDB)) {
        let info =
          rawContentFromDB
            .split("\n")
            .map(line => `${line}`)
            .join("");
        console.log(info, "cejdncjkm");
        html = info
        return info
      }
      else {

        html = JSON.parse(rawContentFromDB).content
        return <div dangerouslySetInnerHTML={{ __html: JSON.parse(rawContentFromDB).content }} />
      }

  }
   const getInfo = (info) => {

          const rawContentFromDB = info
          let html;
          if (!isHTML(rawContentFromDB)) {
              console.log( info,"ckejdnm1")
              let info =
                  rawContentFromDB
                      .split("\n")
                      .map(line => `${line}`)
                      .join("");
              console.log(info, "cejdncjkm");
              html = info
              return info
          }
          else {
             // console.log( info,"ckejdnm2")
              // html = JSON.parse(rawContentFromDB).content
              // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />

                html = JSON.parse(rawContentFromDB).content
                const srcDoc = generateSrcDoc(html);
              return srcDoc
          }

  // "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

      }

  return (
    <div className="container-fluid px-2 px-md-4 py-3">

      {/* Back button */}
      <div className="mb-3">
        <button
          onClick={onClick}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "8px 18px",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            color: "#333",
          }}
        >
          &#8592; Back to Search
        </button>
      </div>

      {/* Main profile card */}
      <div className="profile-all-box">

        {/* Banner */}
        <div className="banner-img-profile">
          <img src="images/profile-cover.png" alt="cover" className="w-100" style={{ height: '200px', objectFit: 'cover', borderRadius: '11px 11px 0 0', border: 'none' }} />
        </div>

        {/* Profile header */}
        <div className="px-3 px-md-4 pt-2 pb-3">
          <div className="row align-items-start">

            {/* Avatar */}
            <div className="col-auto" style={{ marginTop: '-60px' }}>
              <img
                className="public-profile-picture rounded-circle"
                src={PractitionerInfo.general.profile_image !== ""
                  ? process.env.REACT_APP_IMAGE_URL + PractitionerInfo.general.profile_image
                  : "/images/user-dummy.png"}
                alt="avatar"
                style={{ width: '100px', height: '100px', objectFit: 'cover', border: '4px solid #fff' }}
              />
            </div>

            {/* Name + stars */}
            <div className="col mt-2">
              <div className="nam-prof font-weight-bold" style={{ fontSize: '20px', color: '#485257' }}>
                {PractitionerInfo.preferences.screen_name}
              </div>
              <div className="text-muted" style={{ fontSize: '14px' }}>
                {PractitionerInfo.preferences.screen_name}
              </div>
              <div className="mt-1 d-flex align-items-center flex-wrap" style={{ gap: '12px' }}>
                <StarsRating
                  count={5}
                  value={PractitionerInfo.general.average_rating || 0}
                  size={20}
                  color2={"#ffc107"}
                  edit={false}
                  color1={"gray"}
                />
                {canFavorite && (
                  <FavoriteToggle
                    variant="pill"
                    isFavorite={PractitionerInfo.general.is_favorite}
                    disabled={isTogglingFavorite}
                    onToggle={() => onToggleFavorite(PractitionerInfo.general)}
                  />
                )}
              </div>
            </div>

            {/* Book Here button */}
            <div className="col-12 col-sm-auto mt-3 mt-sm-2">
              <div className="profile-book-now" style={{ float: 'none', width: '100%', padding: 0 }}>
                {PractitionerInfo.general.show_flexbooker ? (
                  <a
                    href={PractitionerInfo.general.personal_booking_link !== "" ? PractitionerInfo.general.personal_booking_link : "javascript:void(0);"}
                    className="book-now-practice d-block text-center"
                    style={{ padding: '12px 28px' }}
                  >
                    Book Here
                  </a>
                ) : (
                  PractitionerInfo.general.session_length !== undefined &&
                  PractitionerInfo.general.session_length !== "[]" && (
                    <a
                      href="javascript:void(0);"
                      onClick={
                        PractitionerInfo.general.show_flexbooker
                          ? PractitionerInfo.general.personal_booking_link !== "" ? '' : () => {}
                          : () => getBookingLink(PractitionerInfo.general)
                      }
                      className="book-now-practice d-block text-center"
                      style={{ padding: '12px 28px' }}
                    >
                      Book Here
                    </a>
                  )
                )}
              </div>
            </div>

          </div>
        </div>

        {/* Languages & Country */}
        <div className="profile-details app-new-profile-details">
          <ul className="list-unstyled mb-0">
            <li className="d-flex align-items-start mb-3">
              <div className="icon-detls flex-shrink-0 mr-3">
                <img src="images/chate.png" alt="" />
              </div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <em style={{ display: 'block' }}>Languages Available for Mediumship Sessions:</em>
                <div style={{ flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                  {PractitionerInfo.general.languages.map((data) => (
                    <span key={data.lanugage_name} style={{ display: 'inline-block', border: '1px solid #D5A67B', borderRadius: '5px', padding: '2px 12px', fontSize: '14px', height: 'auto', lineHeight: '26px' }}>{data.lanugage_name}</span>
                  ))}
                </div>
              </div>
            </li>
            <li className="d-flex align-items-center">
              <div className="icon-detls flex-shrink-0 mr-3">
                <img src="images/word.png" alt="" />
              </div>
              <em>Country:</em>
              &nbsp;<a href="#" style={{ color: '#D5A67B' }}>{PractitionerInfo.general.country}</a>
            </li>
          </ul>
        </div>

        {/* About Me */}
        {PractitionerInfo.general.biographical_info !== "" && (
          <div className="profile-bio">
            <h3><b>About Me</b></h3>
            <iframe
              ref={iframeRef}
              srcDoc={getInfo(PractitionerInfo.general.biographical_info)}
              style={{ width: "100%", height: iframeHeight, border: "none" }}
              title="Editor Preview"
            />
          </div>
        )}

        {/* Reviews */}
        <div className="profile-bio">
          <button
            type="button"
            className="btn btn-primary bg-theme-d5a67b height-35 d-block mb-4"
            data-toggle="modal"
            data-target=".bd-example-modal-lg"
          >
            About Our Reviews
          </button>

          {/* About Our Reviews modal */}
          <div className="modal fade bd-example-modal-lg mt-5" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-preview">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">About Our Reviews</h5>
                  <button type="button" className="close about-us-review-close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body p-4 p-md-5">
                  <p className="review-Popup">In an effort to be as transparent as possible, Mediums who have completed a sufficient number of sessions can publish recent reviews from clients (we remove identifying information and confidential details). We don't cherry pick reviews or publish just the positive ones.</p>
                  <br />
                  <p className="review-Popup">We hope you will recognize both the quality of our Mediums and that mediumship is not an exact science and does not work perfectly every time, even for the most experienced Mediums. This balanced view of recent client experiences should give you a sense of the Medium's style and results.</p>
                  <br />
                  <p className="review-Popup">We applaud our Mediums for choosing to publish their reviews, blemishes and all, to help bring more transparency to the mediumship profession.</p>
                </div>
              </div>
            </div>
          </div>

          <h2 className="mb-3">
            Client Reviews{" "}
            {PractitionerInfo.general.recommendation !== ""
              ? `: ${PractitionerInfo.general.recommendation}% Recommend`
              : ""}
          </h2>

          <div className="feedback-container">
            {reviews.map((feedback, idx) => (
              <div key={idx} className="row border-bottom py-3 mx-0">
                <div className="col-12 col-md-4 mb-2 mb-md-0">
                  <div className="d-flex align-items-center">
                    <div className="feedback-image flex-shrink-0">
                      <img className="practioner-profile-image" src="images/user-dummy.png" alt="avatar" />
                    </div>
                    <span className="ml-2" style={{ fontSize: '14px' }}>
                      {feedback.client_name} — {JSON.parse(feedback.feedback).Country}
                    </span>
                  </div>
                  <div className="feedback-star-image mt-1">
                    <StarsRating
                      count={5}
                      value={parseInt(JSON.parse(feedback.feedback).Star_Rating)}
                      size={18}
                      color2={"#ffc107"}
                      edit={false}
                      color1={"#ddd"}
                    />
                  </div>
                  <p className="feedback-date mb-0">{feedback.feedback_date}</p>
                </div>
                <div className="col-12 col-md-8">
                  <span className="feedback-heading d-block">{JSON.parse(feedback.feedback).Title}</span>
                  <span style={{ fontSize: '14px', color: '#555' }}>{JSON.parse(feedback.feedback).Publishable_Feedback}</span>
                </div>
              </div>
            ))}
          </div>

          {hasMoreReviews && (
            <div ref={loadMoreRef} style={{ height: 1 }} />
          )}
          {loadingReviews && (
            <div className="text-center mt-3" style={{ fontSize: "14px", color: "#555" }}>
              Loading…
            </div>
          )}
        </div>

        {/* Payment */}
        {!PractitionerInfo.general.is_pay_forward && (
          <div className="profile-bio">
            <h2 className="mb-3">Pay With:</h2>
            <div className="d-flex flex-wrap" style={{ gap: '12px' }}>
              {PractitionerInfo.general.is_paypal_integrated && (
                <button onClick={() => setPaymentType("paypal")} data-toggle="modal" data-target=".payment-price-popup" className="main-btn">
                  <img src="/integrationimages/paypal.png" alt="PayPal" />
                </button>
              )}
              {PractitionerInfo.general.is_stripe_integrated && (
                <button onClick={() => setPaymentType("stripe")} data-toggle="modal" data-target=".payment-price-popup" className="main-btn">
                  <img className="stripe-img" src="/integrationimages/stripe.png" alt="Stripe" />
                </button>
              )}
              {PractitionerInfo.general.is_square_integrated && (
                <button onClick={() => setPaymentType("squareup")} data-toggle="modal" data-target=".payment-price-popup" className="main-btn">
                  <img className="stripe-square" src="/integrationimages/square-black.jpg" alt="Square" />
                </button>
              )}
            </div>
          </div>
        )}

      </div>

      {/* Payment redirection modal */}
      <div className="modal fade" id="payment-redirection-url" role="dialog" data-backdrop="static">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body text-center p-4">
              <h3>Click Here to Pay</h3>
              <div className="bution-close-accept mt-3">
                <a href={redirectionUrl} target="_blank" rel="noopener noreferrer" className="join-btn pointer">Pay</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <InfoPopup feedBackinfo={active} />
      <PaymentPrices paymentMethodHandler={paymentMethodHandler} setPaymentAmount={setPaymentAmount} />
      <Prepaypostpaycheck mediumSessionInfo={mediumSessionInfo} startSeesion={startSeesion} professionalInfo={professionalInfo} getSubsessions={getSubsessions} />

    </div>
  );
}
